import React from "react";

export default function ManagementGuide() {
  return (
    <div className="flex flex-col">
      <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
          <div className="overflow-hidden border-b border-gray-200 shadow sm:rounded-lg">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-secondary-800">
                <tr>
                  <th
                    scope="col"
                    className="px-6 py-3 text-xs leading-4 tracking-wider text-left text-white uppercase border-b border-gray-200"
                  >
                    Disease Cycle
                  </th>
                  <th
                    scope="col"
                    className="px-6 py-3 text-xs leading-4 tracking-wider text-left text-white uppercase border-b border-gray-200"
                  >
                    Disease Management
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr className="bg-white">
                  <td className="px-6 py-4 text-sm text-gray-700">
                    Ripe rot is a fungal disease caused by{" "}
                    <em>Colletotrichum</em> spp. This pathogen can overwinter in
                    grapevine buds and stem tissues, as well as on weeds and
                    trees surrounding vineyards. During the spring and summer
                    months spores are released and dispersed by rain splash.
                    Under warm and wet conditions, spores can infect. The
                    phenological stage is also critical and increases throughout
                    the season. Grapes become moderately susceptible after berry
                    touch/bunch closure and highly susceptible from veraison to
                    harvest.
                  </td>
                  <td className="px-6 py-4 text-sm text-gray-700">
                    Disease control measures should be targeted around the
                    susceptible phenological stages of the grape cluster. Canopy
                    management aimed at thinning the canopy can reduce stagnant
                    air and moisture, reducing the risk for infection. Infection
                    risk above 0.45 according to the model is considered very
                    high. In replicated trials, fungicides timed during high risk
                    days was able to effectively control ripe rot.
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}
